import axios from "axios";
import authHeader from "@/Api/AuthHeader";
const URL_API =  process.env.VUE_APP_URL_API;

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAllPermissions(){

      return new Promise((resolve, reject)=>{
        axios.get(URL_API+'getAllPermission', {headers:authHeader()})
        .then(response=>resolve(response))
        .catch(error=>reject(error))
      })
    },

    fetchRoles() {
      return new Promise((resolve, reject) => {
        axios
          .get(URL_API+"roles", { headers: authHeader() })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
